module.exports = __webpack_public_path__ + "img/img3.8c794d51.png";